import { createContext } from 'react';

const patUserHealthProfileContext = createContext();
export default patUserHealthProfileContext;
